module.exports = __webpack_public_path__ + "static/social-scholar-ef0c1dd7ca6c976a5607be369cecd874.png";